import {
    ChallengeActionGroupModelDto,
    ChallengeActionsModelDto,
    ChallengeGroupDetailModelDto,
} from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class AuthProfileAction extends DomainEntity<ChallengeActionsModelDto> {
    public static from(dto: ChallengeActionsModelDto): AuthProfileAction {
        return new AuthProfileAction(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id(): number {
        return this.dto.id;
    }

    public get name(): string {
        return this.dto.name ?? '';
    }

    public get description(): string {
        return this.dto.description ?? '';
    }

    public get hoverText(): string {
        return this.dto.hoverText ?? '';
    }

    public get challengeUser(): boolean {
        return this.dto.challengeUser;
    }

    public set challengeUser(value: boolean) {
        this.dto.challengeUser = value;
    }

    public get isThresholdPresent(): boolean {
        return this.dto.isThresholdPresent;
    }

    public get thresholdType(): string {
        return this.dto.thresholdType ?? '';
    }

    public set thresholdType(value: string) {
        this.dto.thresholdType = value;
    }

    public get thresholdAmount(): number | undefined {
        const amt = this.dto.thresholdAmount;
        return isNaN(amt) || amt === undefined ? undefined : amt;
    }

    public set thresholdAmount(value: number | undefined) {
        this.dto.thresholdAmount = value as number;
    }

    public get hasThresholdAmount(): boolean {
        return this.thresholdAmount !== undefined;
    }
}

export class AuthProfileActionGroup extends DomainEntity<ChallengeActionGroupModelDto> {
    public static from(dto: ChallengeActionGroupModelDto): AuthProfileActionGroup {
        return new AuthProfileActionGroup(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id(): number {
        return this.dto.id;
    }

    public get name(): string {
        return this.dto.name ?? '';
    }

    public get description(): string {
        return this.dto.description ?? '';
    }

    public get actions(): AuthProfileAction[] {
        return (this.dto.actions ?? []).map(a => AuthProfileAction.from(a));
    }
}

export class AuthenticationProfileDetail extends DomainEntity<ChallengeGroupDetailModelDto> {
    public static from(dto: ChallengeGroupDetailModelDto): AuthenticationProfileDetail {
        return new AuthenticationProfileDetail(dto);
    }

    public static createNew(): AuthenticationProfileDetail {
        return new AuthenticationProfileDetail({
            id: 0,
            name: '',
            description: '',
            isDefault: false,
            actionGroup: [],
        });
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id(): number {
        return this.dto.id;
    }

    public get name(): string {
        return this.dto.name ?? '';
    }

    public set name(value: string) {
        this.dto.name = value;
    }

    public get description(): string {
        return this.dto.description ?? '';
    }

    public set description(value: string) {
        this.dto.description = value;
    }

    public get isDefault(): boolean {
        return this.dto.isDefault;
    }

    public get isNew(): boolean {
        return this.dto.id === 0;
    }

    public get actionGroups(): AuthProfileActionGroup[] {
        return (this.dto.actionGroup ?? [])
            .filter(g => g.name !== 'PositivePay')
            .map(g => AuthProfileActionGroup.from(g));
    }

    public setAllChallengeUser(value: boolean): void {
        (this.dto.actionGroup ?? []).forEach(group => {
            (group.actions ?? []).forEach(action => {
                action.challengeUser = value;
            });
        });
    }
}
